import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import ResponsiveBreakpointsRolloutBoundary from 'components/ResponsiveBreakpointsRolloutBoundary'
import { RESPONSIVE_BREAKPOINT_PAGES } from 'constants/responsiveBreakpoints'
import NetworkConnection from './NetworkConnection'

export const MyNetworkWithRollout = ({ style = {} }) => {
  const { t } = useTranslation()

  return (
    <ResponsiveBreakpointsRolloutBoundary
      fallback={
        <div aria-live="polite" role="status">
          {t('general.loading')}
        </div>
      }
      page={RESPONSIVE_BREAKPOINT_PAGES.MY_NETWORK}>
      <NetworkConnection style={style} />
    </ResponsiveBreakpointsRolloutBoundary>
  )
}

MyNetworkWithRollout.propTypes = {
  style: PropTypes.object
}

export default MyNetworkWithRollout
